import {Space, Typography} from 'antd';
import React from 'react';
import PropTypes from 'prop-types';
import {selectAuth} from '@app/redux/selectors';
import {connect} from 'react-redux';

const {Text} = Typography;

const WelcomeHeader = ({auth}: any) => {
  return (
    <>
      {/*<Space className={'grid grid-rows-1'}>*/}
      {/*</Space>*/}
      <Space className={'grid grid-rows-1'}>
        <Typography className={'text-2xl mt-2 font-bold'}>
          {/*Welcome, {AuthInfo.getObject(auth).fullNameAndRole}*/}
          Diasol Program
        </Typography>
        <Text>Diabetes Care Management System</Text>
      </Space>
    </>
  );
};

WelcomeHeader.propTypes = {
  auth: PropTypes.object.isRequired,
};

const mapState = (state: any) => {
  const auth = selectAuth(state);
  return {auth};
};

export default connect(mapState)(WelcomeHeader);
